import { SLIDE_REQUEST } from '../mutations_type.js'
import { SLIDER_API } from '../../services/api/api.js'
import axios from 'axios'

const state = {
  slides: [],
}

const getters = {
  SLIDES: state => {
    return state.slides
  },
}

const mutations = {
  [SLIDE_REQUEST]: (state, payload) => {
    state.slides = payload
  },
}

const actions = {
  [SLIDE_REQUEST]: ({ commit }) => {
    axios.get(SLIDER_API).then(response => {
      const data = response.data
      const sliders = data.data
      if (data.code === 0 && sliders) {
        commit('SLIDE_REQUEST', sliders)
      }
    })
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
